/* Stroomkaart - translations table
   ============================================
   Index over per-section files in ./sections/. The section files own
   the actual strings; this file just merges them back into one
   { nl, en } object so i18n.ts's lookup stays unchanged.
*/

import * as common from './sections/common';
import * as home from './sections/home';
import * as map from './sections/map';
import * as requestFlow from './sections/request-flow';
import * as infoPages from './sections/info-pages';
import * as typePages from './sections/type-pages';
import * as audiencePages from './sections/audience-pages';
import * as admin from './sections/admin';
import * as signApprove from './sections/sign-approve';

/* eslint-disable @typescript-eslint/no-explicit-any */
export const translations: { nl: any; en: any } = {
  nl: {
    ...common.nl, ...home.nl, ...map.nl, ...requestFlow.nl, ...infoPages.nl,
    ...typePages.nl, ...audiencePages.nl, ...admin.nl, ...signApprove.nl,
  },
  en: {
    ...common.en, ...home.en, ...map.en, ...requestFlow.en, ...infoPages.en,
    ...typePages.en, ...audiencePages.en, ...admin.en, ...signApprove.en,
  },
};
